import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Table } from "reactstrap";
import { H4 } from "../../AbstractElements";
// import axios from "axios";
import { ServerPath } from "../../Constant";
import { _axios } from '../../utils/axios';

const TopPerformance = () => {
    const [topPerformers, setTopPerformers] = useState([]);

    useEffect(() => {
        const fetchTopPerformers = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/referrals/top-performers`);
                console.log('Response', response);
                if (response.data.success) {
                    setTopPerformers(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching top performers:", error);
            }
        };
        
        fetchTopPerformers();
    }, []);

    return (
        <Card>
            <CardHeader>
                <H4>Top Performance</H4>
            </CardHeader>
            <CardBody className="pt-0">
                <div className="table-responsive">
                    <Table className="table-bordernone">
                        <thead>
                            <tr>
                                <th>Device ID</th>
                                <th>Referrer</th>
                                <th>Mobile No</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {topPerformers.map((performer, index) => (
                                <tr key={index}>
                                    <td>{performer.device_id || ''}</td>
                                    <td>{performer.volunteer_name}</td>
                                    <td>{performer.mobile_no}</td>
                                    <td align='center'>{performer.download_count}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>
    );
};

export default TopPerformance;